<script>
</script>

<style>
    svg {
        position: absolute;
        width: 58.2px;
        height: 13.19px;
        top: 214px;
        left: 14px;
    }

    .cls-1 {
        font-size: 13px;
        fill: #fff;
        font-family: AvenirNext-Regular, Avenir Next, sans-serif;
    }
    .cls-2 {
        letter-spacing: -0.01em;
    }
    .cls-3 {
        letter-spacing: -0.01em;
    }
    .cls-4 {
        letter-spacing: 0;
    }
    .cls-5 {
        letter-spacing: -0.05em;
    }
    .cls-6 {
        letter-spacing: -0.02em;
    }
</style>

<svg id="nextevent-text" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 176.67 25.04">
    <g id="Screenshots">
        <g>
            <path class="cls-1" d="M0,0H4.51l13.4,19.29-4.32-3.26h2.17V0h5.14V24.66h-4.48L2.99,5.26l4.32,3.26h-2.17V24.66H0V0Z"/>
            <path class="cls-1" d="M28.97,23.88c-1.34-.77-2.38-1.87-3.11-3.29-.73-1.42-1.09-3.11-1.09-5.06v-.02c0-1.95,.36-3.64,1.09-5.07,.73-1.43,1.75-2.53,3.07-3.32,1.31-.78,2.87-1.17,4.66-1.17s3.33,.38,4.64,1.14c1.3,.76,2.31,1.83,3.02,3.2,.71,1.38,1.07,2.99,1.07,4.84v1.56h-15.09v-3.16h12.73l-2.38,2.96v-1.93c0-1.07-.17-1.97-.5-2.69-.33-.72-.79-1.27-1.38-1.63-.59-.36-1.27-.55-2.04-.55s-1.46,.19-2.06,.56c-.6,.38-1.06,.93-1.4,1.65-.34,.72-.5,1.61-.5,2.66v1.95c0,1,.17,1.86,.5,2.58s.82,1.27,1.44,1.65c.63,.38,1.37,.57,2.24,.57,.68,0,1.28-.11,1.78-.32,.5-.22,.91-.49,1.23-.82,.32-.33,.54-.67,.65-1.01l.03-.1h4.58l-.05,.19c-.14,.67-.4,1.35-.8,2.03s-.94,1.31-1.62,1.88c-.68,.57-1.5,1.03-2.48,1.37-.97,.34-2.12,.51-3.43,.51-1.87,0-3.47-.38-4.82-1.15Z"/>
            <path class="cls-1" d="M49.98,15.53l-5.69-9.19h5.62l3.3,6.19h.1l3.25-6.19h5.43l-5.72,9.06,5.67,9.26h-5.42l-3.49-6.34h-.1l-3.44,6.34h-5.26l5.74-9.13Z"/>
            <path class="cls-1" d="M67.62,23.75c-.98-.85-1.47-2.26-1.47-4.22V10.1h-2.55v-3.76h2.55V1.86h5.04V6.34h3.35v3.76h-3.35v8.89c0,.85,.19,1.45,.57,1.79,.38,.34,.95,.5,1.7,.5,.23,0,.43,0,.6-.03s.33-.04,.48-.06v3.66c-.27,.05-.61,.09-1.02,.13-.4,.04-.87,.06-1.39,.06-2.03,0-3.53-.43-4.51-1.28Z"/>
            <path class="cls-1" d="M86.39,0h16.34V4.26h-11.18v5.91h10.54v4.05h-10.54v6.19h11.18v4.26h-16.34V0Z"/>
            <path class="cls-1" d="M105.38,6.34h5.35l3.83,13.91h.1l3.78-13.91h5.21l-6.29,18.32h-5.64l-6.34-18.32Z"/>
            <path class="cls-1" d="M129.16,23.88c-1.35-.77-2.38-1.87-3.11-3.29-.73-1.42-1.09-3.11-1.09-5.06v-.02c0-1.95,.37-3.64,1.09-5.07,.73-1.43,1.75-2.53,3.07-3.32,1.32-.78,2.87-1.17,4.66-1.17s3.34,.38,4.64,1.14c1.3,.76,2.31,1.83,3.02,3.2,.71,1.38,1.07,2.99,1.07,4.84v1.56h-15.09v-3.16h12.73l-2.38,2.96v-1.93c0-1.07-.17-1.97-.5-2.69-.33-.72-.79-1.27-1.38-1.63-.59-.36-1.27-.55-2.04-.55s-1.46,.19-2.06,.56c-.6,.38-1.07,.93-1.4,1.65-.34,.72-.5,1.61-.5,2.66v1.95c0,1,.17,1.86,.5,2.58s.82,1.27,1.44,1.65c.63,.38,1.37,.57,2.24,.57,.68,0,1.28-.11,1.78-.32,.5-.22,.91-.49,1.23-.82,.32-.33,.54-.67,.65-1.01l.04-.1h4.58l-.05,.19c-.14,.67-.41,1.35-.8,2.03s-.94,1.31-1.61,1.88c-.68,.57-1.5,1.03-2.48,1.37-.97,.34-2.12,.51-3.43,.51-1.87,0-3.47-.38-4.82-1.15Z"/>
            <path class="cls-1" d="M145.94,6.34h4.99v3.01h.1c.48-1.05,1.18-1.87,2.12-2.48,.93-.6,2.09-.91,3.47-.91,2.02,0,3.57,.61,4.67,1.82s1.65,2.9,1.65,5.05v11.83h-4.99V13.88c0-1.2-.28-2.12-.85-2.79-.56-.66-1.4-.99-2.52-.99-.74,0-1.38,.17-1.93,.51s-.97,.81-1.27,1.42c-.3,.6-.45,1.3-.45,2.1v10.53h-4.99V6.34Z"/>
            <path class="cls-1" d="M169.75,23.75c-.98-.85-1.47-2.26-1.47-4.22V10.1h-2.55v-3.76h2.55V1.86h5.04V6.34h3.35v3.76h-3.35v8.89c0,.85,.19,1.45,.57,1.79,.38,.34,.95,.5,1.7,.5,.23,0,.43,0,.6-.03,.17-.02,.33-.04,.48-.06v3.66c-.27,.05-.61,.09-1.02,.13-.41,.04-.87,.06-1.39,.06-2.03,0-3.53-.43-4.51-1.28Z"/>
        </g>
    </g>
</svg>
